var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModify = function SvgModify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "modify_svg__st0",
    d: "M7.05 22.81 1.15 24A.978.978 0 0 1 0 22.85l1.19-5.9 5.86 5.86zM2.646 15.492l11.563-11.56 5.86 5.864L8.508 21.355zM17.87.27l-2.21 2.21 5.86 5.86 2.21-2.21c.38-.38.38-1 0-1.38L19.25.27c-.38-.38-1-.38-1.38 0z"
  })));
};
export default SvgModify;